export enum AgreementState {
	active = 1,
	cancelled = 2,
	draft = 3,
	waitingPayment = 4,
}
